// test948
(948 && 0);
